import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>Sobre Nós</h2>
    <p>{`Fundada por ex-funcionários do Google e especializada em Marketing Digital.`}</p>
    <p>{`Nosso objetivo é gerar resultados através de campanhas de performance no meio online e construir relacionamentos duradouros com nossos clientes.`}</p>
    <p>{`Somos especialistas em diversas plataformas para executar estratégias inteligentes independentemente do segmento, público ou objetivo que se deseja alcançar.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      